import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  ComposeEmailResolver,
  ComposeEmailPreloaderService,
  ComposeEmailWarmUpModalResolver,
  ComposeEmailService,
  ComposeEmailPreviewService,
  ComposeEmailPreviewRepository,
  ComposeEmailPreviewMessagesService,
  ComposeEmailPreviewMessagesRepository,
  ComposeEmailSenderFormService,
  ComposeEmailSubjectFormService,
  ComposeEmailContentFormService,
  ComposeEmailSendTimeFormService,
  ComposeEmailRecipientsFormService,
  ComposeTestEmailRecipientsFormService,
  ComposeEmailFollowUpFormService,
}

export type ComposeEmailServices = keyof typeof SERVICES

export const COMPOSE_EMAIL_TYPES: Record<ComposeEmailServices, symbol> = makeServicesTypes<ComposeEmailServices>(
  enumKeysToArray<ComposeEmailServices>(SERVICES),
)
